export default "__VITE_ASSET__OHognC8S__"